module.exports = __webpack_public_path__ + "img/Toxotai64_ua.ace1a6e4.webp";